 /**
 * Created by Shiv Roy on 21/11/17.
 */
import { showFormatedDate, showFormattedTime, base64Encode, showFormatedDateandTime } from '../../../../actions/utilAction';
import classNames from 'classnames';
import { isValidNameWithSpace, renderCheckBox, renderDateField, renderTextArea, renderTextField, renderTimePicker } from '../../../../components/reduxFields';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
// import PatientInfo from '../../patient_info';
import React from 'react';
import history from '../../../../history';
import moment from 'moment';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from 'material-ui/Table';

import { getPatientSingleEncounters } from '../../actions/PatientActions';

class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apptid: props.match.params.apptid,
      encid: props.match.params.id,
      patientId: null,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      renderingProviderName: '',
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
    };
    this.handleBackClick = this.handleBackClick.bind(this);    
  }

  componentWillMount() {
    let searchObj = {
      'apptId': this.state.apptid,
      'encounterId': this.state.encid,
    };
    this.props.getPatientSingleEncounters(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && this.props.singleEncounter !== nextProps.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffNames = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffNames.push(staff.staffName);
        });

        let renderingProviderNames = [];
        appointmentData.appointmentRenderingProviders.forEach((staff) => {
          renderingProviderNames.push(staff.renderingProviderName);
        });

        this.setState({
          patientId: appointmentData.patientID,
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          renderingProviderName: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
        });

        let soapObj = nextProps.singleEncounter;
        let guardianSignObj = {}, clientSignObj = {}, employeeSignObj = {}, renderingProviderSignObj = {};
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              guardianSignObj = data;
            }
            if (signObj.patientSign) {
              let data = {
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: nextProps.singleEncounter.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              clientSignObj = data;
            }
            if (signObj.clinicianSign) {
              let data = {
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: staffNames && staffNames ? staffNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              employeeSignObj = data;
            }
            if (signObj.renderingProviderSign) {
              let data = {
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                Name: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              renderingProviderSignObj = data;
            }
          });
        }
        this.setState({
          ClientSign: clientSignObj,
          GuardianSign: guardianSignObj,
          EmployeeSign: employeeSignObj,
          enderingProviderSign : renderingProviderSignObj,
        });
      }
    }

    if (nextProps.dateOfNextSession && this.props.dateOfNextSession !== nextProps.dateOfNextSession) {   
      this.setState({ DateOfNextSession: nextProps.dateOfNextSession, ScoringDateOfService: nextProps.scoringDateOfService
        , ReportWritingDateOfService: nextProps.reportWritingDateOfService
        , ScoringTimeIn: nextProps.scoringTimeIn
        , ScoringTimeOut: nextProps.scoringTimeOut
        , ReportWritingTimeIn: nextProps.reportWritingTimeIn
        , ReportWritingTimeOut: nextProps.reportWritingTimeOut
      });     
    }
    
  }

  renderDiagnosis() {
    if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else {
      if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length !== 0) {
        return this.props.initialValues.diagnosisArray.map((diagnosis, index) => {
          if (diagnosis.IsDeleted) {
            return <tr key={index}><td colSpan='3'><span className='redfont'>{diagnosis.description}</span></td></tr>;
          }
          return (
            <tr key={index}>
              <td width="30%">{diagnosis.icdCode}</td>
              <td width="70%">{diagnosis.description ? diagnosis.description : ''}</td>
              {/* <td width="10%"><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont">Remove</button></td>*/}
            </tr>
          );
        });
      }
    }
  }


  renderCpt() {
    if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length !== 0) {
      return this.props.initialValues.CPTTableData.map((cpt, index) => {
        if (cpt.IsDeleted) {
          return <tr key={index}><td colSpan='3'><span className='redfont'>{cpt.serviceCode}</span></td></tr>;
        }
        return (
          <tr key={index}>
            <td width="20%">{cpt.serviceCode ? cpt.serviceCode : '-'}</td>
            <td width="30%">{cpt.attachedModifiers ? cpt.attachedModifiers : '-'}</td>
            <td width="50%">{cpt.description ? cpt.description : '-'}</td>
          </tr>
        );
      });
    }
  }

  handleBackClick = () => {
    let encPatientId = this.state.patientId ? base64Encode(`${this.state.patientId}`) : null;
    if (this.props.location.state && this.props.location.state.isRedirectFromPatientEncounter && encPatientId) {
      history.push(`/client/encounter/${encPatientId}`);
    } else {
      history.push('/dashboard');
    }
  };
    
  render() {
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });

    let totalUnitsConsumed = (this.props.singleEncounter && this.props.singleEncounter.unitsConsumed) || 0;

    return (
      <div>
        {/* <h2 className="page_title">Client Encounter</h2>
        <PatientInfo patientId={this.state.patientid} />
        <div className="clearfix"></div> */}
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <CommonButton label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
                  <div className='col-sm-12' >              
                    <Field
                    name="ServiceCoordinatorName"
                    type="text"
                    maxLength="40"
                    normalize={isValidNameWithSpace}
                    label="Service Coordinator Name"
                    disabled={true}
                    component={renderTextField}                 
                    />
                  </div> 
              </div>
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Type Of Service:</h5><span style={{ color: 'red'}}>*</span>                
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DirectTherapy"
                    label="Direct Therapy"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="MakeUp"
                    label="Make Up"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Evaluation"
                    label="Evaluation"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IFSPMeeting"
                    label="IFSP Meeting"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TeleTherapy"
                    label="Tele Therapy"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IFSPDevTime"
                    label="IFSP Dev Time"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProviderCancelled"
                    label="Provider Cancelled"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FamilyCancelled"
                    label="Family Cancelled"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="NoCall"
                    label="No Call"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="InterpreterCancelled"
                    label="Interpreter Cancelled"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTypeofService"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTypeofService &&
                  (<div className='col-sm-4'>
                  <Field
                    name="OtherTypeofServiceNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div> 

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Who Participated in Therapy/ Meeting(s):</h5><span style={{ color: 'red'}}>*</span>                 
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Mom"
                    label="Mom"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Dad"
                    label="Dad"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Caregiver"
                    label="Caregiver"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Siblings"
                    label="Siblings"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GrandParent"
                    label="Grand Parent"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ServiceCoordinator"
                    label="Service Coordinator"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherParticipated"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherParticipated &&
                  (<div className='col-sm-4'>
                  <Field
                    name="OtherParticipatedNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div> 


              <div className="row mt-35">
                <div className='col-sm-12' >                    
                    <Field
                    name="InterpreterPresent"
                    type="text"
                    maxLength="40"
                    normalize={isValidNameWithSpace}
                    label="Interpreter Present (Y/N)"
                    disabled={true}
                    component={renderTextField}
                    />
                  </div>
                <div className="col-sm-3 require">                    
                  <Field
                    name="ScoringDateOfService"
                    placeholder="Scoring Date Of Service"
                    component={renderDateField}
                    locale="en-US"
                    openToYearSelection={true}
                    minDate={new Date()}
                    selected={this.state.ScoringDateOfService}
                    onDateChange={this.onDateChange} />
                </div> 
                <div className="col-sm-3 require wd_full">
                  <Field
                      name="ScoringTimeIn"
                      placeholder="Scoring Time In"
                      fullWidth={true}
                      disabled={true}                    
                      component={renderTimePicker}
                      selected={this.state.ScoringTimeIn}
                      onDateChange={this.onDateChange}

                    />
                </div>
                <div className="col-sm-3 require wd_full">
                  <Field
                      name="ScoringTimeOut"
                      placeholder="Scoring Time Out"
                      fullWidth={true}
                      disabled={true}                    
                      component={renderTimePicker}
                      selected={this.state.ScoringTimeOut}
                      onDateChange={this.onDateChange}
                    />
                </div>
                <div className="col-sm-12 require">       
                  <Field
                    name="ScoringDescription"
                    type="text"
                    fullWidth={true}
                    label="Scoring Description"
                    // autoHeight={true}
                    rows={6}
                    disabled={true}
                    component={renderTextArea}                    
                  />
                </div>

                
                <div className="col-sm-3 require">                    
                  <Field
                    name="ReportWritingDateOfService"
                    placeholder="Report Writing Date Of Service"
                    component={renderDateField}
                    locale="en-US"
                    openToYearSelection={true}
                    minDate={new Date()}
                    selected={this.state.ReportWritingDateOfService}
                    onDateChange={this.onDateChange} />
                </div> 
                <div className="col-sm-3 require wd_full">
                  <Field
                      name="ReportWritingTimeIn"
                      placeholder="Report Writing Time In"
                      fullWidth={true}
                      disabled={true}                    
                      component={renderTimePicker}
                      selected={this.state.ScoringTimeIn}
                      onDateChange={this.onDateChange}

                    />
                </div>
                <div className="col-sm-3 require wd_full">
                  <Field
                      name="ReportWritingTimeOut"
                      placeholder="Report Writing Time Out"
                      fullWidth={true}
                      disabled={true}                    
                      component={renderTimePicker}
                      selected={this.state.ReportWritingTimeOut}
                      onDateChange={this.onDateChange}
                    />
                </div>
                <div className="col-sm-12 require">       
                  <Field
                    name="ReportWritingDescription"
                    type="text"
                    fullWidth={true}
                    label="Report Writing Description"
                    // autoHeight={true}
                    rows={6}
                    disabled={true}
                    component={renderTextArea}                    
                  />
                </div>
              </div>

              <div className="row mt-35">
                <div className='col-sm-12' >
                  <Field
                    name="ParentalIssues"
                    type="text"
                    fullWidth={true}
                    label="News/Parental Issues or Concerns"
                    rowsCount = {6}
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}                   
                  />
                </div>
                <div className='col-sm-12' >
                  <Field
                    name="HomeProgramUpdate"
                    type="text"
                    fullWidth={true}
                    label="Home Program Update: (from Previous week)  0  1  2 (0  No follow up reported, 1 parent reported follow up, 2 parent reported follow up and Improvement observed)"
                    rowsCount = {6}
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>
                <div className='col-sm-12' >
                  <Field
                    name="Goals"
                    type="text"
                    fullWidth={true}
                    label="Goals/Areas/Routines we worked on today"
                    rowsCount = {6}
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>
                <div className='col-sm-12' >
                  <Field
                    name="Summary"
                    type="text"
                    fullWidth={true}
                    label="Summary of Session"
                    rowsCount = {6}
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>
                <div className='col-sm-12' >
                  <Field
                    name="ParentOutcomes"
                    type="text"
                    fullWidth={true}
                    label="Parent/Caregiver Outcomes"
                    rowsCount = {6}
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>
                <div className='col-sm-12' >
                  <Field
                    name="NextSessionTherapyPlan"
                    type="text"
                    fullWidth={true}
                    label="Next Session Therapy Plan"
                    rowsCount = {6}
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>
                <div  className='col-sm-12 require' >              
                    <Field
                      name="DateOfNextSession"
                      placeholder="Date Of Next Session"
                      component={renderDateField}
                      locale="en-US"
                      openToYearSelection={true}
                      minDate={new Date()}
                      disabled={true}
                      selected={this.state.DateOfNextSession}
                      onDateChange={this.onDateChange} />
                  </div>   
              </div>  
            
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Diagnosis</h3>
                    <i className="flaticon flaticon-gym"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderDiagnosis()}
                  </TableBody>
                </Table>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Service Codes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="20%">Service Code</TableHeaderColumn>
                      <TableHeaderColumn width="30%">Modifiers</TableHeaderColumn>
                      <TableHeaderColumn width="50%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderCpt()}
                  </TableBody>
                </Table>
              </div>
              { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                  {this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                  }
                  {this.state.RenderingProviderSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                              <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                </div>
                : ''}
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const selector = formValueSelector('EncounterForm');
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  //let initialData = {};
  let initialData = {
    challengingBXModel: [{}],
    skillAcquisitionModel: [{}]
  };  
  let appointmentTime = null;
  if (state.patient.singleEncounter && state.patient.singleEncounter) {
   
    if (state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation) {      
      
      initialData['InterpreterPresent'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.interpreterPresent;
      initialData['ScoringDateOfService'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.scoringDateOfService;
      initialData['ScoringDescription'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.scoringDescription;
      initialData['ScoringTimeIn'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.scoringTimeIn;
      initialData['ScoringTimeOut'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.scoringTimeOut;
   
      initialData['ReportWritingDateOfService'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.reportWritingDateOfService;
      initialData['ReportWritingDescription'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.reportWritingDescription;
      initialData['ReportWritingTimeIn'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.reportWritingTimeIn;
      initialData['ReportWritingTimeOut'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.reportWritingTimeOut;

      initialData['ParentalIssues'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.parentalIssues;
      initialData['HomeProgramUpdate'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.homeProgramUpdate;
      initialData['Goals'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.goals;
        
      initialData['Summary'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.summary;
      initialData['ParentOutcomes'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.parentOutcomes;

      initialData['NextSessionTherapyPlan'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.nextSessionTherapyPlan;
      initialData['ServiceCoordinatorName'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.serviceCoordinatorName;
      initialData['DateOfNextSession'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.dateOfNextSession;

        // ObservedBehavior_Session_Hyperion
        initialData['DirectTherapy'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.directTherapy;
        initialData['MakeUp'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.makeUp;
        initialData['Evaluation'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.evaluation;
        initialData['IFSPMeeting'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.ifspMeeting;
        initialData['TeleTherapy'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.ifspDevTime;
        initialData['IFSPDevTime'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.observedVocal;

        initialData['ProviderCancelled'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.providerCancelled;
        initialData['FamilyCancelled'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.familyCancelled;
        initialData['NoCall'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.noCall;
        initialData['InterpreterCancelled'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.interpreterCancelled;
       
        initialData['OtherTypeofService'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.otherTypeofService;
        initialData['OtherTypeofServiceNotes'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_TypeofService.otherTypeofServiceNotes;
       
        // ebS_IllinoisEvaluation_ParticipatedInTherapy
        initialData['Mom'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_ParticipatedInTherapy.mom;
        initialData['Dad'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_ParticipatedInTherapy.dad;
        initialData['Caregiver'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_ParticipatedInTherapy.caregiver;
        initialData['Siblings'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_ParticipatedInTherapy.siblings;
        initialData['GrandParent'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_ParticipatedInTherapy.grandParent;        
        initialData['ServiceCoordinator'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_ParticipatedInTherapy.serviceCoordinator;
       
        initialData['OtherParticipated'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_ParticipatedInTherapy.otherParticipated;
        initialData['OtherParticipatedNotes'] = state.patient.singleEncounter.sessionNotes_EBS_IllinoisEvaluation.ebS_IllinoisEvaluation_ParticipatedInTherapy.otherParticipatedNotes;

    }

    if (state.patient.singleEncounter.patientEncounterDiagnosisCodes) {
      initialData['diagnosisArray'] = state.patient.singleEncounter.patientEncounterDiagnosisCodes;
    }
    if (state.patient.singleEncounter.patientEncounterServiceCodes) {
      initialData['CPTTableData'] = state.patient.singleEncounter.patientEncounterServiceCodes;
    }

    // if(state.patient.singleEncounter.appointmentStartDateTime){
    //   let startTimehours = state.patient.singleEncounter.appointmentStartDateTime.substr(11, 2);
    //   let endTimehours = state.patient.singleEncounter.appointmentEndDateTime.substr(11, 2);
    //   let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ?
    //     (parseInt(startTimehours, 10) - 12 < 10 ?
    //       `0${parseInt(startTimehours, 10) - 12}`
    //       : startTimehours)
    //     : startTimehours;
    //   let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;
    //   let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
    //   let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
    //   appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.appointmentStartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.appointmentEndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
    //   initialData['appointmentTime'] = appointmentTime;
    // }

    // console.log('state.patient.singleEncounter.............', state.patient.singleEncounter);

    if (state.patient.singleEncounter.startDateTime) {
      let startTimehours = state.patient.singleEncounter.startDateTime.substr(11, 2);
      let endTimehours = state.patient.singleEncounter.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }


    initialData['locationName'] = state.patient.singleEncounter.locationName;
    initialData['staffName'] = state.patient.singleEncounter.staffName;
    initialData['appointmentDate'] = state.patient.singleEncounter.patientAppointment.startDateTime;
    initialData['PatientLocationName'] = state.patient.singleEncounter.PatientLocationName;
    initialData['serviceEndTime'] = moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('HH:mm:ss');

  }

  return {
    selectorOtherTypeofService: selector(state, 'OtherTypeofService'),
    selectorOtherParticipated: selector(state, 'OtherParticipated'),

    singleEncounter: state.patient.singleEncounter,
    initialValues: initialData,  
    dateOfNextSession: initialData && initialData.DateOfNextSession ? initialData.DateOfNextSession : '',
    scoringDateOfService: initialData && initialData.ScoringDateOfService ? initialData.ScoringDateOfService : '',
    reportWritingDateOfService: initialData && initialData.ReportWritingDateOfService ? initialData.ReportWritingDateOfService : '',

    scoringTimeIn: initialData && initialData.ScoringTimeIn ? initialData.ScoringTimeIn : '',
    scoringTimeOut: initialData && initialData.ScoringTimeOut ? initialData.ScoringTimeOut : '',

    reportWritingTimeIn: initialData && initialData.ReportWritingTimeIn ? initialData.ReportWritingTimeIn : '',
    reportWritingTimeOut: initialData && initialData.ReportWritingTimeOut ? initialData.ReportWritingTimeOut : '',
  };

}
export default connect(mapStateToProps, { getPatientSingleEncounters })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/patients/components/Encounter/SessionNotes_Encounter_Illinois_Evaluation_EBS.js